const AddModes = Object.freeze({
  OFF: 0,
  CHOOSE_COORDINATES: 1,
  DESCRIBE_ITEM: 2,
  EDIT_ITEM: 3,
});

export { AddModes };
